// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__VCXFt","selects":"Documents_selects__3vACi"};